import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../../hooks/use-http";
import convertToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import { AutoComplete } from "antd";
import html2canvas from "html2canvas";
import Modal from "react-modal";
import { useAuth } from "../../../../../store/auth";
import jsPDF from "jspdf";
import { toast } from "react-toastify";

const PlotMappingTjoe = (props) => {
  const frmRef = useRef({});
  const printRef = useRef();
  const { orgData } = useAuth();
  const navigate = useNavigate();
  const pdfContainerRef = useRef(null);
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const url = localStorage.getItem("organizationIcon");

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };

  const generatePDF = (title = "PlotMappingReports") => {
    const input = pdfContainerRef.current;
    if (!input) return;

    html2canvas(input, {
      scale: 2,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const contentWidth = canvas.width;
      const contentHeight = canvas.height;

      // Convert PX → PT (1px = 0.75pt)
      const pdfWidth = contentWidth * 0.75;
      const pdfHeight = contentHeight * 0.75;

      // Create PDF with CUSTOM page height
      const pdf = new jsPDF("p", "pt", [pdfWidth, pdfHeight]);

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      pdf.save(`${title}.pdf`);
    });
  };




  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [seasonId, setSeasonId] = useState([]);
  const [seasondata, setSeasondata] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropData, setCropData] = useState([]);

  const [stateData, setStatedata] = useState([]);

  const [stateId, setStateId] = useState();
  const [stateName, setStateName] = useState();

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();


  // const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);

  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);

  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [fields, setFields] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);

  const [exportFields, setExportFields] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const { sendRequest: getPlotMappingData } = useHttp();


  const [logoBase64, setLogoBase64] = useState("");

  const [logoSrc, setLogoSrc] = useState("");

  const fillPlotMappingData = (employeeId, seasonId, regionId, farmerNo, cropId) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId != "0" && employeeId != "") {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }
    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }
    if (farmerNo && farmerNo.trim() !== "") {
      urlfilter += `&farmerNo=${farmerNo.trim()}`;
    }
    if (cropId && cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerCropPlotTJReport/?page=${currentPage}&page_size=${itemsPerPage}&orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getPlotMappingData(
      {
        url: url,
      },
      (res) => {
        console.log("reportdata", res);
        setData(res?.results?.data || []);
        setTotalCount(res?.count || 0);
        if (res) {
          const activeFields = (res?.results?.fields || [])
            .filter((f) => f.status === 1)
            .sort((a, b) => a.sequenceNo - b.sequenceNo);

          setFields(activeFields);
          const fieldsToExport = activeFields?.map((f) => f.dataField);
          const customHeaders = activeFields?.map((f) => f.headerField);

          setExportFields(fieldsToExport);
          setExportHeaders(customHeaders);
        }
      }
    );
  };

  const { sendRequest: getCropData } = useHttp();

  useEffect(() => {
    getCropData(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("cropData", data);
        setCropData(data.output || []);
      }
    );
  }, [getCropData]);

  useEffect(() => {
    fillPlotMappingData(
      employeeId,
      seasonId,
      regionId,
      farmerNumber,
      cropId,

    );
  }, [
    currentPage,
    employeeId,
    seasonId,
    regionId,
    ranchId,
    fieldName,
    farmerNumber,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
    stateName,
    cropId
  ]);

  useEffect(() => {
    if (!data || data.length === 0) {
      setFieldOptions([]);
      return;
    }

    let filteredData = data;

    if (ranchId && ranchId > 0) {
      const selectedRanch = ranchData.find(
        (x) => String(x.ranchId) === String(ranchId)
      );

      if (selectedRanch) {
        filteredData = data.filter(
          (item) => item.ranchName === selectedRanch.ranchName
        );
      }
    }

    const uniqueFields = [
      ...new Set(
        filteredData
          .map((item) => item.plotCode)
          .filter(Boolean)
      ),
    ];

    const fieldList = uniqueFields.map((f) => ({
      plotCode: f,
    }));

    setFieldOptions(fieldList);
  }, [ranchId, ranchData, data]);

  const handleExportExcel = async () => {
    try {
      var urlfilter = "";

      if (showDateFilter) {
        urlfilter += `&fromDate=${selectedFromDate}`;
        urlfilter += `&toDate=${selectedToDate}`;
      }

      if (employeeId && employeeId !== "0") {
        urlfilter += `&fieldExecutiveId=${employeeId}`;
      }

      if (regionId > 0) {
        urlfilter += `&regionId=${regionId}`;
      }

      if (ranchId > 0) {
        urlfilter += `&ranchId=${ranchId}`;
      }

      if (fieldName && fieldName !== "") {
        urlfilter += `&fieldId=${fieldName}`;
      }

      if (seasonId > 0) {
        urlfilter += `&seasonId=${seasonId}`;
      }

      if (farmerNumber && farmerNumber.trim() !== "") {
        urlfilter += `&farmerNo=${farmerNumber.trim()}`;
      }

      if (cropId && cropId !== "") {
        urlfilter += `&cropId=${cropId}`;
      }

      if (stateName && stateName.trim().length > 0) {
        urlfilter += `&stateName=${stateName}`;
      }

      const url = `/api/farmerCropPlotTJReport/?export=excel&orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

      getPlotMappingData(
        {
          url: url,
        },
        (res) => {
          const exportData = res?.data || [];

          if (exportData.length === 0) {
            toast.error("No data available to export!");
            return;
          }

          const processedData = exportData.map((item) => {
            const coordinates = JSON.parse(item.plotCoordinates || "[]");

            const latitude = coordinates
              .map((coord) => coord.latitude)
              .join(", ");

            const longitude = coordinates
              .map((coord) => coord.longitude)
              .join(", ");

            return {
              ...item,
              latitude,
              longitude,
            };
          });

          const filteredExportFields = exportFields.filter(
            (field) => field !== "view"
          );

          const filteredExportHeaders = exportHeaders.filter(
            (header) => header !== "View"
          );

          convertToExcel(
            processedData,
            filteredExportFields,
            "PlotMapping.xlsx",
            filteredExportHeaders
          );
        }
      );
    } catch (error) {
      console.error(error);
      toast.error("Excel export failed!");
    }
  };



  const exportToExcel = () => {
    const filename = "PlotMapping_With_Images.xlsx";

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");

      let imageUrl = "No Image";
      if (item.plotPhotosUrls) {
        const urls = JSON.parse(item.plotPhotosUrls);
        if (urls.length > 0 && urls[0]) {
          imageUrl = `${process.env.REACT_APP_FILE_URL}${urls[0]}`;
        }
      }

      return {
        ...item,
        latitude,
        longitude,
        plotPhotosUrls: imageUrl,
        // createdDate: item.createdDate
        //   ? new Date(item.createdDate).toLocaleDateString("en-GB")
        //   : "",
      };
    });

    const fieldsToExportWithImages = [...exportFields, "plotPhotosUrls"];
    const customHeadersWithImages = [...exportHeaders, "Plot Image URL"];

    convertToExcel(
      processedData,
      fieldsToExportWithImages,
      filename,
      customHeadersWithImages
    );
  };

  const { sendRequest: getEmp } = useHttp();
  const EmployeeDetail = (region) => {
    const url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
      "empId"
    )}&orgId=${localStorage.getItem("orgId")}${region > 0 ? `&regionId=${region}` : ""
      }`;
    getEmp({ url }, (data) => setEmployeeData(data));
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, []);


  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/plotFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  const exportToExcelWithImages = () => {
    const filename = "PlotMapping_With_Images.xlsx";

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");

      let imageUrl = "No Image";
      if (item.plotPhotosUrls) {
        try {
          const urls = JSON.parse(item.plotPhotosUrls);
          if (urls.length > 0 && urls[0]) {
            imageUrl = `${process.env.REACT_APP_FILE_URL}${urls[0]}`;
          }
        } catch {
          imageUrl = "No Image";
        }
      }

      return {
        ...item,
        latitude,
        longitude,
        plotPhotosUrls: imageUrl,
        // createdDate: item.createdDate
        //   ? new Date(item.createdDate).toLocaleDateString("en-GB")
        //   : "",
      };
    });

    const fieldsToExportWithImages = [...exportFields, "plotPhotosUrls"];
    const customHeadersWithImages = [...exportHeaders, "Plot Image URL"];

    convertToExcel(
      processedData,
      fieldsToExportWithImages,
      filename,
      customHeadersWithImages
    );
  };
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const inputCost = Number(pdfData?.harvestDetail?.[0]?.inputCost || 0);
  const serviceCost = Number(pdfData?.harvestDetail?.[0]?.serviceCost || 0);
  const harvestCost = Number(pdfData?.harvestDetail?.[0]?.finalAmount || 0);


  const totalCost = inputCost + serviceCost;


  const totalPayable = totalCost - harvestCost;

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const [profileInfo, setprofileInfo] = useState([]);

  const { sendRequest: getPlotmapp } = useHttp();

  const viewPdf = (item) => {
    setPdfView(true);

    if (item?.cropId) {
      getPlotmapp(
        {
          url: `/api/farmerStatementReport/?orgId=${localStorage.getItem(
            "orgId"
          )}&cropId=${item.cropId}`,
        },
        (res) => {
          if (res) {
            setprofileInfo(res.farmerInfo); // keep if needed elsewhere
            setPdfData(res); // ✅ this makes pdfData.inputs and pdfData.services work
            setprofileInfo(res.farmerInfo);
            console.log("farmerStatementReport", res);
          }
        }
      );
    }
  };
  useEffect(() => {
    // Force logo name → TomatoJOLogo.jpg
    const imagePath = `/dist/img/TomatoJOLogo.jpg`;

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imagePath;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      setLogoSrc(canvas.toDataURL("image/png"));
    };

    img.onerror = () => {
      console.error("Logo not found:", imagePath);
      setLogoSrc("");
    };
  }, []);
  const formatNGN = (value) => {
    return value ? Number(value).toLocaleString("en-NG", {
      style: "currency",
      currency: "NGN",
    }) : "₦0.00";
  };



  return (
    <>
      <div className="content-wrapper">
        {/* Filters Section */}
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3"> Field Allocation </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />

        <section className="content">
          <div className="container-fluid">
            {/* Filters */}
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {cropData &&
                      cropData.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);

                    }}
                  >
                    <option value="">Select</option>
                    {seasondata &&
                      seasondata.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value || 0);
                      setFieldName("");

                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.plotCode}>
                        {x.plotCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              {/* Employee Filter */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      const userid =
                        e.target.value !== "--Select--" ? e.target.value : 0;
                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData.map((x) => (
                      <option key={x.userId} value={x.userId}>
                        {x.employeeName}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="date_filter">Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {/* From & To Date */}
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit Button */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={() =>
                      fillPlotMappingData(
                        employeeId,
                        seasonId,
                        regionId,
                        farmerNumber,
                        ranchId,
                        cropId

                      )
                    }
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Table Section */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          {fields?.map((field, idx) => (
                            <th key={idx}>{field.headerField}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          data.map((item, rowIndex) => (
                            <tr key={rowIndex} className="tablerowview">
                              {fields?.map((field, colIndex) => {
                                const value = item[field.dataField];


                                if (field.dataField === "view") {
                                  return (
                                    <td key={colIndex}>
                                      <button
                                        type="button"
                                        onClick={() => viewPdf(item)}
                                        className="btn"
                                      >
                                        <i className="fas fa-eye"></i>
                                      </button>
                                    </td>
                                  );
                                }


                                if (field.dataField === "plotPhotosUrls") {
                                  let photos = [];
                                  try {
                                    photos = JSON.parse(value || "[]");
                                  } catch {
                                    photos = [];
                                  }

                                  return (
                                    <td key={colIndex}>
                                      {photos.map((photo, idx) => (
                                        <img
                                          key={idx}
                                          src={`${process.env.REACT_APP_FILE_URL}${photo}`}
                                          alt=""
                                          width="60"
                                          height="60"
                                          style={{
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            margin: "2px",
                                          }}
                                        />
                                      ))}
                                    </td>
                                  );
                                }


                                if (field.dataField === "latitude") {
                                  let coordinates = [];
                                  try {
                                    coordinates = JSON.parse(item.plotCoordinates || "[]");
                                  } catch {
                                    coordinates = [];
                                  }
                                  return (
                                    <td key={colIndex} style={{ whiteSpace: "pre-line" }}>
                                      {coordinates.map((c) => c.latitude?.toFixed(6)).join("\n")}
                                    </td>
                                  );
                                }


                                if (field.dataField === "longitude") {
                                  let coordinates = [];
                                  try {
                                    coordinates = JSON.parse(item.plotCoordinates || "[]");
                                  } catch {
                                    coordinates = [];
                                  }
                                  return (
                                    <td key={colIndex} style={{ whiteSpace: "pre-line" }}>
                                      {coordinates.map((c) => c.longitude?.toFixed(6)).join("\n")}
                                    </td>
                                  );
                                }

                                return (
                                  <td key={colIndex}>
                                    {typeof value === "number"
                                      ? value.toLocaleString("en-IN")
                                      : value}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </tbody>
                    </table>

                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={totalCount}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container">
            {/* Close Button */}
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <button
                  type="button"
                  className="btn btn-tool"
                  onClick={() => setPdfView(false)}
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>

            {/* PDF Content */}
            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="invoice p-3 mb-3"
                        style={{ border: "5px solid #ddd", padding: "20px" }}
                      >
                        {/* Header */}
                        <div className="row">
                          <div className="col-3">&nbsp;</div>

                          <div className="col-6 text-center">
                            <div>
                              {logoSrc && (
                                <img
                                  src={logoSrc}
                                  width="55"
                                  height="55"
                                  alt="logo"
                                />
                              )}

                            </div>
                            <div>
                              <h4 style={{ marginTop: "10px" }}>
                                Farmer Statement
                                <br />
                                {localStorage.getItem("organizationName")}
                              </h4>
                            </div>

                            {localStorage.getItem("organizationAddress")}
                          </div>
                        </div>

                        <hr />

                        {/* Farmer & Ranch Info */}
                        <div className="row">
                          <div className="col-6">
                            <h6
                              style={{
                                backgroundColor: "#7c570cff",
                                color: "#fff",
                                padding: "5px",
                              }}
                            >
                              Farmer Detail
                            </h6>
                            <table className="table table-sm table-bordered">
                              <tbody>
                                <tr>
                                  <td>Name</td>
                                  <td>{profileInfo?.[0]?.farmerName}</td>
                                </tr>
                                <tr>
                                  <td>Farmer No</td>
                                  <td>{profileInfo?.[0]?.farmerNo}</td>
                                </tr>
                                <tr>
                                  <td>Address</td>
                                  <td>{profileInfo?.[0]?.address}</td>
                                </tr>

                                <tr>
                                  <td>State</td>
                                  <td>{profileInfo?.[0]?.state}</td>
                                </tr>
                                <tr>
                                  <td>LGA</td>
                                  <td>{profileInfo?.[0]?.lga}</td>
                                </tr>
                                <tr>
                                  <td>Mobile No</td>
                                  <td>{profileInfo?.[0]?.mobile}</td>
                                </tr>
                                <tr>
                                  <td>Plot No</td>
                                  <td>{profileInfo?.[0]?.plotName}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-6">
                            <h6
                              style={{
                                backgroundColor: "#7c570cff",
                                color: "#fff",
                                padding: "5px",
                              }}
                            >
                              Plot Mapping Info
                            </h6>
                            <table className="table table-sm table-bordered">
                              <tbody>
                                <tr>
                                  <td>Ranch Name </td>
                                  <td>{profileInfo?.[0]?.ranchName}</td>
                                </tr>
                                <tr>
                                  <td>Field Name</td>
                                  <td>{profileInfo?.[0]?.plotCode}</td>
                                </tr>

                                <tr>
                                  <td>Plot Area</td>
                                  <td>
                                    {profileInfo?.[0]?.plotArea} &nbsp;
                                    {profileInfo?.[0]?.plotAreaUnit}
                                  </td>
                                </tr>

                                <tr>
                                  <td>Crop Name</td>
                                  <td>{profileInfo?.[0]?.cropName}</td>
                                </tr>
                                <tr>
                                  <td>Crop Variety</td>
                                  <td>{profileInfo?.[0]?.cropVariety}</td>
                                </tr>

                                <tr>
                                  <td>Season Name</td>
                                  <td>{profileInfo?.[0]?.seasonName}</td>
                                </tr>
                                <tr>
                                  <td>Budget Template</td>
                                  <td>{profileInfo?.[0]?.farmerBudgetTemplateName}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div>Note:All values are in NGS</div>

                        {/* Inputs Detail */}
                        <h6
                          style={{
                            backgroundColor: "#7c570cff",
                            color: "#fff",
                            padding: "5px",
                          }}
                        >
                          Inputs Detail
                        </h6>
                        <table className="table table-bordered">
                          <thead
                            style={{
                              backgroundColor: "#0c7c59",
                              color: "#ffffffff",
                            }}
                          >
                            <tr>
                              <th>#</th>
                              <th>Item & Description</th>
                              <th>Qty</th>
                              <th>Rate</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pdfData?.issueProductresult?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  <div>{item.productName}</div>
                                  <div
                                    style={{ fontSize: "12px", color: "#555" }}
                                  >
                                    {item.productSubTypeName},{" "}
                                    {item.productTypeName}
                                  </div>
                                </td>
                                <td>
                                  {item.useQty} {item.unitAbbreviation}
                                </td>
                                <td>{item.salesRate}</td>
                                <td>{formatNGN(item.useAmt)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Service Detail */}
                        <h6
                          style={{
                            backgroundColor: "#7c570cff",
                            color: "#fff",
                            padding: "5px",
                          }}
                        >
                          Service Detail
                        </h6>
                        <table className="table table-bordered">
                          <thead
                            style={{
                              backgroundColor: "#0c7c59",
                              color: "#fff",
                            }}
                          >
                            <tr>
                              <th>#</th>
                              <th>Service & Description</th>
                              <th>Qty</th>

                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pdfData?.serviceData?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  <div>{item.productName}</div>
                                  <div
                                    style={{ fontSize: "12px", color: "#555" }}
                                  >
                                    {item.productSubTypeName},{" "}
                                    {item.productTypeName}
                                  </div>
                                </td>
                                <td>
                                  {profileInfo?.[0]?.plotArea}&nbsp;
                                  {item.unitAbbreviation}
                                </td>

                                <td>{formatNGN(item.totalProductAmount)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {/* Service Detail */}
                        <h6
                          style={{
                            backgroundColor: "#7c570cff",
                            color: "#fff",
                            padding: "5px",
                          }}
                        >
                          Harvest Details
                        </h6>
                        <table className="table table-bordered">
                          <thead
                            style={{
                              backgroundColor: "#0c7c59",
                              color: "#fff",
                            }}
                          >
                            <tr>
                              <th>#</th>
                              <th>Harvest Description</th>
                              {/* <th>Crates</th> */}
                              <th>Qty</th>

                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pdfData?.harvestDetail?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <div>{item.varietyName}</div>
                                <div
                                  style={{ fontSize: "12px", color: "#555" }}
                                >
                                  {item.cropName},{" "}
                                </div>
                                <td>{item.finalQuantity}</td>
                                <td>{formatNGN(item.finalAmount)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Totals & Payment */}
                        <div className="row">
                          <div className="col-6">
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <th>Account Holder Name</th>
                                  <td>
                                    {pdfData?.harvestDetail?.[0]?.accountHolderName || ""}
                                  </td>
                                </tr>

                                <tr>
                                  <th>Account Number</th>
                                  <td>
                                    {pdfData?.harvestDetail?.[0]?.accountNumber || ""}
                                  </td>
                                </tr>

                                <tr>
                                  <th>Bank Name</th>
                                  <td>
                                    {pdfData?.harvestDetail?.[0]?.bankName || ""}
                                  </td>
                                </tr>

                                <tr>
                                  <th>IFSC Code</th>
                                  <td>
                                    {pdfData?.harvestDetail?.[0]?.ifscCode || ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="col-6">
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <th>A. Input Detail Total</th>
                                  <td>{inputCost.toFixed(2)}</td>
                                </tr>

                                <tr>
                                  <th>B. Service Cost</th>
                                  <td>{serviceCost.toFixed(2)}</td>
                                </tr>

                                <tr>
                                  <th>C. Subtotal (A+B)</th>
                                  <td>{totalCost.toFixed(2)}</td>
                                </tr>

                                <tr>
                                  <th>D. Total Harvest Cost</th>
                                  <td>{harvestCost.toFixed(2)}</td>
                                </tr>

                                <tr>
                                  <th>E. Total Payable (C-D)</th>
                                  <td>{totalPayable.toFixed(2)}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>


                        {/* Footer */}
                        <p
                          className="text-muted text-center"
                          style={{ marginTop: "20px" }}
                        >
                          This is a computer-generated document.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            {/* Download Button */}
            <div className="row no-print">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary float-right"
                  onClick={() => generatePDF(pdfData?.docNo)}
                >
                  <i className="fas fa-download" /> Generate PDF
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PlotMappingTjoe;
